import { mergeMap, switchMap } from 'rxjs/operators';

import { catchApiError } from '@cbridge-packages/api';
import { ICollectorApiDependencySegment } from '@cbridge-packages/api-collector';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';

import { ExposureAction } from '../exposure.action';

type IDependencies = ICollectorApiDependencySegment;

export const loadSymbolListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ExposureAction.loadSymbolList.started),
  switchMap((params) => {
    return dependencies.clApi.getExposure(params).pipe(
      mergeMap((response) => {
        return [
          ExposureAction.loadSymbolList.done({ params, result: response.symbols }),
        ];
      }),
      catchApiError((error) => {
        return [
          ExposureAction.loadSymbolList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
